// import React from "react";
// import styles from "./DeleteAccount.module.css";
// import { useForm } from "react-hook-form";
// import { z } from "zod";
// import { zodResolver } from "@hookform/resolvers/zod";
// import toast from "react-hot-toast";

// // Zod Schema for form validation
// const deleteAccountSchema = z.object({
//   email: z.string().email({ message: "Invalid email address" }),
//   // password: z.string(),
// });

// export default function DeleteAccount() {
//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//   } = useForm({
//     resolver: zodResolver(deleteAccountSchema),
//   });

//   const onSubmit = (data) => {
//     console.log("Form Submitted", data);
//     toast.success("Your account will be deleted permanently within 90 days");
//     // Send DELETE request to your backend here
//   };

//   return (
//     <div className={styles.wrapper}>
//       <div className={styles.container}>
//         <h1 className={styles.title}>Delete Your Footfall Account</h1>
//         <p className={styles.subtitle}>We're sorry to see you go.</p>
//         <p className={styles.description}>
//           This page allows you to permanently delete your account from{" "}
//           <strong>Footfall</strong>. All your data including activity history
//           will be erased and cannot be recovered. Please enter your email and
//           password to confirm your identity before proceeding.
//         </p>

//         <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
//           <div className={styles.formGroup}>
//             <input
//               type="email"
//               placeholder="Enter your email"
//               {...register("email")}
//               className={styles.input}
//             />
//             {errors.email && (
//               <span className={styles.error}>{errors.email.message}</span>
//             )}
//           </div>
//           {/* <div className={styles.formGroup}>
//             <input
//               type="password"
//               placeholder="Enter your password"
//               {...register("password")}
//               className={styles.input}
//             />
//             {errors.password && (
//               <span className={styles.error}>{errors.password.message}</span>
//             )}
//           </div> */}
//           <button type="submit" className={styles.button}>
//             Delete Account
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// }








import React from "react";
import styles from "./DeleteAccount.module.css";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

// Zod Schema for form validation
export default function DeleteAccount() {
  const { t } = useTranslation();

  const deleteAccountSchema = z.object({
    email: z.string().email({ message: t("deleteAccount.errors.invalidEmail") }),
    // password: z.string(),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(deleteAccountSchema),
  });

  const onSubmit = (data) => {
    console.log("Form Submitted", data);
    toast.success(t("deleteAccount.toast.success"));
    // Send DELETE request to your backend here
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <h1 className={styles.title}>{t("deleteAccount.title")}</h1>
        <p className={styles.subtitle}>{t("deleteAccount.subtitle")}</p>
        <p className={styles.description}>
          {t("deleteAccount.description", { appName: t("title") })}
        </p>

        <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
          <div className={styles.formGroup}>
            <input
              type="email"
              placeholder={t("deleteAccount.placeholder.email")}
              {...register("email")}
              className={styles.input}
            />
            {errors.email && (
              <span className={styles.error}>{errors.email.message}</span>
            )}
          </div>

          {/* Uncomment if password is required
          <div className={styles.formGroup}>
            <input
              type="password"
              placeholder={t("deleteAccount.placeholder.password")}
              {...register("password")}
              className={styles.input}
            />
            {errors.password && (
              <span className={styles.error}>{errors.password.message}</span>
            )}
          </div>
          */}

          <button type="submit" className={styles.button}>
            {t("deleteAccount.button")}
          </button>
        </form>
      </div>
    </div>
  );
}

